module.exports = __webpack_public_path__ + "img/icon_sportMenu_UEFA.1bfdafaf.svg";